import { appRoutes } from './appRoutes';

export const SNOWFLAKE_ALLOWED_ROUTES: readonly string[] = [
  appRoutes.getStarted.route,
  appRoutes.agenticLayer.route,
  appRoutes.documentation.route,
  appRoutes.environments.route,
  appRoutes.settings.route,
];

/** Menu section IDs (not real routes) that Snowflake orgs can see — sub-items are filtered by SNOWFLAKE_ALLOWED_ROUTES */
export const SNOWFLAKE_ALLOWED_MENU_IDS: readonly string[] = ['apps1'];

export const isSnowflakeAllowedRoute = (pathname: string): boolean => {
  return SNOWFLAKE_ALLOWED_ROUTES.some((route) => pathname.includes(route));
};
